import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppUserListDataApi(data) {
  return request({
    url: "web/appUser/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadAppUserExportDataApi(data) {
  return request({
    url: "web/appUser/exportData",
    method: "post",
    data
  });
}

// 根据条件查询数量
export function findAppUserCountByConditionApi(data) {
  return request({
    url: "web/appUser/findCountByCondition",
    method: "post",
    data
  });
}

// 根据条件查询用户
export function findAppUserByConditionApi(data) {
  return request({
    url: "web/appUser/findByCondition",
    method: "post",
    data
  });
}

// 初始化
export function initAppUserApi(data) {
  return request({
    url: "web/appUser/init",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppUserApi(data) {
  return request({
    url: "web/appUser/saveOrUpdate",
    method: "post",
    data
  });
}

// 用户门店信息列表(主数据列表)
export function loadAppUserStoreRelationListDataApi(data) {
  return request({
    url: "web/appUserStoreRelation/listData",
    method: "post",
    data
  });
}

// 用户门店信息导出(主数据列表)
export function loadAppUserStoreRelationExportDataApi(data) {
  return request({
    url: "web/appUserStoreRelation/exportData",
    method: "post",
    data
  });
}

// 用户成长值数据
export function listAppUserIntegralListDataApi(data) {
  return request({
    url: "web/appUserIntegral/listSelectData",
    method: "post",
    data
  });
}